import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  TEAM_GET_REQUEST,
  TEAM_GET_SUCCESS,
  TEAM_GET_FAILURE,
  TEAM_GET_RESET,
  TEAM_LIST_REQUEST,
  TEAM_LIST_SUCCESS,
  TEAM_LIST_FAILURE,
  TEAM_LIST_RESET,
  TEAM_CREATE_REQUEST,
  TEAM_CREATE_SUCCESS,
  TEAM_CREATE_FAILURE,
  TEAM_CREATE_RESET,
  TEAM_EDIT_REQUEST,
  TEAM_EDIT_SUCCESS,
  TEAM_EDIT_FAILURE,
  TEAM_EDIT_RESET,
  TEAM_DEACTIVATE_REQUEST,
  TEAM_DEACTIVATE_SUCCESS,
  TEAM_DEACTIVATE_FAILURE,
  TEAM_DEACTIVATE_RESET,
  TEAM_EXPORT_REQUEST,
  TEAM_EXPORT_SUCCESS,
  TEAM_EXPORT_FAILURE,
  TEAM_EXPORT_RESET,
} from './../../constants'

export function getTeam(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/teams`,
      method: 'GET',
      types: [
        TEAM_LIST_REQUEST,
        TEAM_LIST_SUCCESS,
        TEAM_LIST_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function getTeamByID(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/teams/${id}`,
      method: 'GET',
      types: [
        TEAM_GET_REQUEST,
        TEAM_GET_SUCCESS,
        TEAM_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function createTeam(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/teams`,
      method: 'POST',
      types: [
        TEAM_CREATE_REQUEST,
        TEAM_CREATE_SUCCESS,
        TEAM_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function editTeam(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/teams/${id}`,
      method: 'PUT',
      types: [
        TEAM_EDIT_REQUEST,
        TEAM_EDIT_SUCCESS,
        TEAM_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function deactivateTeam(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/teams/${id}/delete`,
      method: 'PUT',
      types: [
        TEAM_DEACTIVATE_REQUEST,
        TEAM_DEACTIVATE_SUCCESS,
        TEAM_DEACTIVATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function exportTeam(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/lobs/exports`,
      method: 'GET',
      types: [
        TEAM_EXPORT_REQUEST,
        TEAM_EXPORT_SUCCESS,
        TEAM_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}


export function resetListTeam() {
  return {
    type: TEAM_LIST_RESET,
  }
}
export function resetCreateTeam() {
  return {
    type: TEAM_CREATE_RESET,
  }
}
export function resetEditTeam() {
  return {
    type: TEAM_EDIT_RESET,
  }
}
export function resetGetTeam() {
  return {
    type: TEAM_GET_RESET,
  }
}
export function resetDeactivateTeam() {
  return {
    type: TEAM_DEACTIVATE_RESET,
  }
}
export function resetExportTeam() {
  return {
    type: TEAM_EXPORT_RESET,
  }
}




// WEBPACK FOOTER //
// ./src/actions/team/team-action.js